import { lazy, Suspense } from "react";
import { Navbar } from "@/components/marketing/Navbar";
import { Hero } from "@/components/marketing/Hero";
import { SEOHead } from "@/components/SEOHead";
import { getLocalBusinessSchema } from "@/data/businessInfo";

// Below-the-fold sections — lazy loaded to reduce initial bundle
const BelowFold = lazy(() => import("@/components/marketing/BelowFoldSections"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Wedding & Event Florist in Cass City, MI | Kim"
        description="Custom wedding & event floral design by Kim, a former Disney florist with 40+ years of experience. Serving Cass City, MI and surrounding areas."
        canonical="https://kimfloraldesigns.com"
        schema={getLocalBusinessSchema()}
      />
      <Navbar />
      <Hero />
      <Suspense fallback={null}>
        <BelowFold />
      </Suspense>
    </div>
  );
};

export default Index;
